import bp from './brakePoints';
import Swiper from 'swiper';

let $hero = $('.js-hero-index'),
	$slider = $hero.find('.js-hero-index-bg'),
	$slider2 = $hero.find('.js-hero-index-widgets'),
	isSlider = false,
	pause = +$hero.data('timeout'),
	timer = 0,
	timeout,
	rafCache,
	circle = 176,
	tick = circle / pause,
	$btns = $hero.find('.js-hero-index-control'),
	$btn = $btns.filter('.active'),
	$chrome = $btn.find('circle'),
	btnIsHovered = false;

// фоновый слайдер с картинками
if (!!$slider.length) {
	let bg,
		slidesCount = $slider.find('.swiper-slide').length;
	
	bg = new Swiper($slider[0], {
		speed: 1000,
		effect: 'fade',
		loop: true,
		fadeDuration: 2000
	});
	
	bg.on('transitionStart', function() {
		$btn = $btns.eq(bg.realIndex < slidesCount ? bg.realIndex : 0);
		prepareBtn();
		$btn.addClass('active').siblings().removeClass('active');
		timer = 0;
	});
	
	bg.on('transitionEnd', function() {
		window.cancelAnimationFrame(rafCache);
		raf();
	});
	
	raf();
	
	function prepareBtn() {
		$chrome = $btn.find('circle');
		$chrome.css('stroke-dashoffset', circle);
	}
	
	// рисуется полоска на кнопке
	function raf() {
		if (timer > pause) {
			bg.slideNext();
		} else {
			if (!btnIsHovered) {
				$chrome.css('stroke-dashoffset', circle - tick * timer++);
			}
			rafCache = requestAnimationFrame(raf);
		}
	}
	
	$('.js-hero-index-controls').on({
		mouseenter: function() {
			btnIsHovered = true;
		},
		mouseleave: function() {
			btnIsHovered = false;
		}
	});
	
	$btns.click(function() {
		let $c = $(this);
		if ($c[0] === $btn[0]) {
			return false;
		}
		$btn = $(this);
		window.cancelAnimationFrame(rafCache);
		bg.slideToLoop($btns.index($btn));
		btnIsHovered = false;
	});
}

// слайдер с виджетами
if (!!$slider2.length) {
	let widgets;
	
	window.addEventListener('bpChanged', onResize);
	
	function onResize() {
		if (['phone', 'phone-big', 'tablet'].includes(bp.current)) {
			if (!isSlider) {
				isSlider = true;
				
				widgets = new Swiper($slider2[0], {
					spaceBetween: 20,
					slidesPerView: 2,
					slidesPerGroup: 1,
					// freeMode:true,
					// freeModeSticky: true,
					// freeModeMomentum: true,
					// freeModeMomentumRatio:0.2,
					pagination: {
						el: '.js-hero-index-info-dots',
						type: 'bullets',
						clickable: true
					},
					breakpoints: {
						// when window width is <= 320px
						800: {
							slidesPerView: 1,
							spaceBetween: 20
						},
						// when window width is <= 480px
						1159: {
							slidesPerView: 2,
							spaceBetween: 20
						}
					}
				});
			}
		} else {
			if (isSlider) {
				isSlider = false;
				
				widgets.destroy(true, true);
			}
		}
	}
	
	onResize();
}
